import { ProductData } from 'types/ProductData'
import { StyledOtherProductsMob } from './style'
import { Button, Carousel } from '../../../../ui'
import { useIntl } from 'react-intl'
import {ReactNode} from "react";

interface OtherProductsMobProps {
  products?: ProductData[]
  slidesPerRow?: number
  children?: ReactNode
  farm_name?: string
  title?: string
}

const OtherProductsMob = ({ products, farm_name, title, slidesPerRow, children }: OtherProductsMobProps) => {
  const intl = useIntl()

  const responsive = [
    {
      breakpoint: 590,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 1150,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1484,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1760,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 9999,
      settings: {
        slidesToShow: 5,
      },
    },
  ];

  
  const renderTitle = () => {
    if (title) {
      return <h1>{title}</h1>;
    }

    if (farm_name) {
      const farmMessage = `${intl.formatMessage({
        id: 'popular_products.other',
      })} ${farm_name} ${intl.formatMessage({
        id: 'popular_products.production',
      })}`;
      return <h1>{farmMessage}</h1>;
    }

    return <h1>{intl.formatMessage({ id: 'popular_products.title' })}</h1>;
  };

  return (
    <StyledOtherProductsMob>
      <div className={'container'}>
        {children}
        <div className={'title'}>
          <div className='title'>{renderTitle()}</div>
        </div>
        <div className={'row'}>
          <Carousel
            responsive={responsive}
            products={products}
            dots={true}
            adaptiveHeight={true}
            slidesPerRow={slidesPerRow || 5}
            draggable={true}
          />
        </div>
      </div>
    </StyledOtherProductsMob>
  );
};

export default OtherProductsMob;
